// extracted by mini-css-extract-plugin
export default {"infiniteScrollInnerContainer":"PalletsTransferHistory_infiniteScrollInnerContainer__B3Px7","infiniteScrollOuterLoader":"PalletsTransferHistory_infiniteScrollOuterLoader__+0100"};